module.exports = __webpack_public_path__ + "img/zhangwei.614e2dba.jpg";